export const validURL = value => (value && /^(ftp|http|https):\/\/[^ "]+$/.test(value) ? undefined : 'Invalid URL')
export const required = value => (value ? undefined : 'Required')
